import React from 'react'

const TestimonialsHero = () => {
  return (
    <div className="contact-hero-container">
    <div className="content">

        <div className="contact-header-section">
            <h1>
            Testimonials
            </h1>
            <p>
            What our clients have to say
            </p>

        </div>
    </div>
</div>
  )
}

export default TestimonialsHero